import { render, staticRenderFns } from "./OrdersRates.vue?vue&type=template&id=17138b88&scoped=true"
import script from "./OrdersRates.vue?vue&type=script&lang=js"
export * from "./OrdersRates.vue?vue&type=script&lang=js"
import style0 from "./OrdersRates.vue?vue&type=style&index=0&id=17138b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17138b88",
  null
  
)

export default component.exports